import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { getResolveRoute } from '@mews-commander/legacy-app-instance';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { openModal } from './common';

export const getCustomerDetailUrl = createSelector(getResolveRoute, getStringProp('id'), (resolveRoute, id) =>
    resolveRoute(RouteName.CustomerDetail, { id })
);

export function openCustomerDetail(id: string): CommanderThunkAction {
    return (dispatch, getState, { resolveRoute }) => {
        const url = resolveRoute(RouteName.CustomerDetail, { id });
        return dispatch(openModal(url));
    };
}

export function openCustomerInternals(id: string): CommanderThunkAction {
    return (dispatch, getState, { resolveRoute }) => {
        const RouteNameInternals = RouteName.CustomerInternals;
        const url = resolveRoute(RouteNameInternals, { id });
        return dispatch(openModal(url));
    };
}

export const getCustomerRegistrationCardUrl = createSelector(
    getResolveRoute,
    getStringProp('id'),
    getCurrentEnterpriseId,
    (resolveRoute, id, enterpriseId) =>
        resolveRoute(RouteName.CustomerRegistrationCard, { id, query: { enterpriseId, ForPrint: 'True' } })
);
